import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=2ea66b6e&scoped=true&lang=pug"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=2ea66b6e&prod&scoped=true&lang=css"
import style1 from "./dialog.vue?vue&type=style&index=1&id=2ea66b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea66b6e",
  null
  
)

export default component.exports